export default "__VITE_ASSET__cTOb4z69__"